import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const ilmuMujadilah11: Quote = {
  id: "ilmu-mujadilah-11",
  name: "Keutamaan Ilmu",
  emoji: "📖",
  category: "Ilmu & Hikmah",
  description:
    "Allah akan meninggikan derajat orang-orang yang beriman dan **orang-orang yang diberi ilmu** beberapa derajat.",
  detail:
    "Ayat ini menegaskan bahwa ilmu memiliki kedudukan tinggi dalam Islam. Bukan sekadar pengetahuan duniawi, tapi juga **ilmu yang membawa seseorang lebih dekat kepada Allah**. Menuntut ilmu adalah ibadah, dan mengamalkannya adalah amanah.",
  tldr: "Allah tinggikan derajat orang berilmu — menuntut ilmu itu ibadah.",
  story: createQuoteStory("Keutamaan Ilmu", "📖", [
    { hook: {
      title: "Pernah mikir, ngapain sih capek-capek belajar?",
      body: "Ternyata Islam punya pandangan yang **luar biasa tinggi** tentang orang yang menuntut ilmu...",
    } },
    { source: {
      arabic: "يَرْفَعِ اللَّهُ الَّذِينَ آمَنُوا مِنكُمْ وَالَّذِينَ أُوتُوا الْعِلْمَ دَرَجَاتٍ",
      body: "Allah akan meninggikan orang-orang yang beriman di antaramu dan orang-orang yang diberi **ilmu beberapa derajat**.",
      title: "QS. Al-Mujadilah: 11",
    } },
    { reveal: {
      body: "Ilmu bukan cuma soal ijazah atau gelar. Ilmu yang dimaksud adalah **pemahaman yang mengubah cara kamu hidup** — lebih bijak, lebih rendah hati, lebih dekat dengan kebenaran.",
    } },
    { insight: {
      title: "Ilmu yang mengangkat derajat",
      body: "Rasulullah ﷺ bersabda: **\"Menuntut ilmu itu wajib bagi setiap Muslim.\"** (HR. Ibnu Majah). Bukan hanya ilmu agama — semua ilmu yang bermanfaat untuk umat adalah mulia di sisi Allah.",
    } },
    { engagement: {
      title: "Ilmu apa yang lagi kamu pelajari sekarang?",
      body: "Apapun itu, **niatkan karena Allah**. Share ayat ini ke teman yang lagi semangat belajar! 📚",
    } },
  ]),
  related: ["sabar-baqarah-153"],
};
